import type {UavPointCloudRepository} from '@/domain/interfaces/UavPointCloudRepository';

export class DeleteUavPointCloudsUseCase {
  constructor(private readonly repository: UavPointCloudRepository) {}
  async execute(pointCloudUuid: string) {
    return await this.repository.delete(pointCloudUuid);
  }
}
